import { ContactFormValues, ContactSuccessResponse } from "./types";
import api, { handleResponse } from "../../../services/api";
import { apiPaths } from "../../../utils/constants";
import * as ActionType from "./actions";

const submitContactForm = (values: ContactFormValues, dispatch: any): void => {
  api
    .post<ContactSuccessResponse, ContactFormValues>(apiPaths.contactUs, values)
    .then((response) => {
      const action = handleResponse<ContactSuccessResponse>(
        response,
        ActionType.CONTACTUS_SUBMIT_SUCCESS,
        ActionType.CONTACTUS_SUBMIT_FAILURE
      );

      dispatch(action);
    })
    .catch((err) => {
      const action = handleResponse<{}>(
        err.response,
        ActionType.CONTACTUS_SUBMIT_SUCCESS,
        ActionType.CONTACTUS_SUBMIT_FAILURE
      );
      dispatch(action);
    });
};

const clearAlert = (dispatch: any): void => {
  dispatch({
    type: ActionType.CLEAR_CONTACTUS_MESSAGE,
    payload: null,
  });
};

export { submitContactForm, clearAlert };
